import React from 'react'
import Canvas from './Canvas'

const FilterCreator3000 = () => {
    return (
        <div>
            <Canvas />
        </div>
    )
}

export default FilterCreator3000
